// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 103, 163, 1%29%27 stroke-linecap=%27%27 stroke-miterlimit=%2710%27 stroke-width=%273%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    z-index: 9999;
    background: var(--white);
    padding: 10px;
    box-shadow: 0 8px 15px 0 rgba(0,0,0,.05);
    position: fixed;
    width: 100%;
    background: var(--white);
}
.navbar .container-fluid {
    max-width: 1900px;
}
.navbar .container-fluid .navbar-collapse.collapse {
    float: right;
}
.navbar li {
    padding: 0px 20px 0px 20px;
}
.navbar li a {
    color: var(--principale) !important;
    font-size: 16px;
    font-weight: 600;
}

/*Sottomenu*/
.dropdown-menu {
    padding: 0px;
    border-radius: 10px 10px 10px 10px;
    border: none;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.dropdown-menu li {
    padding: 0px;
}
.dropdown-menu li a:hover {
    background: var(--secondario);
    color: var(--white) !important;
}
.dropdown-menu li a {
    padding: 13px 20px 13px 28px;
    font-size: 13px;
    color: var(--grigioScuro) !important;
}
.dropdown-menu li:first-child a {
    border-radius: 10px 10px 0px 0px;
}
.dropdown-menu li:last-child a {
    border-radius: 0px 0px 10px 10px;
}



/*Bottoni*/
.navbar .bottone {
    font-size: 16px !important;
    font-weight: 600;
    margin-right: 16px;
}
.bottoni a {
    color: var(--principale);
}

.logoMenu {
    width: 160px;
}

.navbar-nav .vociMenu {
    display: flex;
}



/*Voci solo a mobile*/
.solo-mobile {
    display: none;
}
@media only screen and (max-width: 992px) {
    .solo-mobile {
        display: block;
    }
    .dropdown {
        display: none;
    }
}
/*-------------------------------MOBILE MENU-----------------------------------*/
/*Burger icon:*/
.navbar .navbar-toggler {
    border: none;
    color: var(--principale);
}
.navbar .navbar-toggler:focus {
    border: none;
}
.navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/*Close button:*/
.navbar .close-button {
    display: none;
    background: none;
    border: none;
    font-weight: 900;
    color: var(--principale);
}


/* Fa arrivare il menu a mobile da sx invece che dall'alto*/
@media (max-width: 992px) {
    .navbar-collapse.collapsing .navbar-nav {
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: -45%;
        transition: all 0.2s ease;
    }
    .navbar-collapse.show .navbar-nav {
        background: var(--secondario);
        z-index: 9;
        width: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        flex-direction: column;
        height: auto;
        transition: left 0.35s ease;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }
    .navbar-nav .vociMenu {
        display: block;
        padding: 30px 20px 40px 20px;
    }
    .navbar-nav .vociMenu a {
        color: var(--white) !important;
        font-size: 24px;
        font-weight: 500;
        line-height: 20px;
        padding: 14px 0px 14px 0px;
    }
    .navbar-nav li .bottoni {
        display: none;
    }
    /*Close button*/
    .navbar .close-button {
        display: block;
        position: absolute;
        top: 35px;
        right: 35px;
    }
}


/*Contenuto Top del menu mobile aperto*/
.container-top-menu-mobile .logo {
    margin-bottom: 20px;
}
.container-top-menu-mobile {
    display: none;
    padding: 60px 25px 33px 25px;
    background: var(--white);
}
@media only screen and (max-width: 992px) {
    .container-top-menu-mobile {
        display: block;
    }
}
.navbar-nav .onda {
    transform: translateY(-2px);
}
.navbar-nav .onda path {
    fill: var(--white);
}

`, "",{"version":3,"sources":["webpack://./src/style/Menu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,aAAa;IACb,wCAAwC;IACxC,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,+CAA+C;AACnD;AACA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,4BAA4B;IAC5B,eAAe;IACf,oCAAoC;AACxC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;;;;AAIA,UAAU;AACV;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;;;AAIA,qBAAqB;AACrB;IACI,aAAa;AACjB;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;AACJ;AACA,gFAAgF;AAChF,eAAe;AACf;IACI,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,yDAAqP;AACzP;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;;AAGA,2DAA2D;AAC3D;IACI;QACI,cAAc;QACd,eAAe;QACf,MAAM;QACN,SAAS;QACT,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,UAAU;QACV,WAAW;QACX,eAAe;QACf,MAAM;QACN,SAAS;QACT,OAAO;QACP,sBAAsB;QACtB,YAAY;QACZ,2BAA2B;QAC3B,6CAA6C;IACjD;IACA;QACI,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,8BAA8B;QAC9B,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA,eAAe;IACf;QACI,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;AACJ;;;AAGA,uCAAuC;AACvC;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".navbar {\n    z-index: 9999;\n    background: var(--white);\n    padding: 10px;\n    box-shadow: 0 8px 15px 0 rgba(0,0,0,.05);\n    position: fixed;\n    width: 100%;\n    background: var(--white);\n}\n.navbar .container-fluid {\n    max-width: 1900px;\n}\n.navbar .container-fluid .navbar-collapse.collapse {\n    float: right;\n}\n.navbar li {\n    padding: 0px 20px 0px 20px;\n}\n.navbar li a {\n    color: var(--principale) !important;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n/*Sottomenu*/\n.dropdown-menu {\n    padding: 0px;\n    border-radius: 10px 10px 10px 10px;\n    border: none;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);\n}\n.dropdown-menu li {\n    padding: 0px;\n}\n.dropdown-menu li a:hover {\n    background: var(--secondario);\n    color: var(--white) !important;\n}\n.dropdown-menu li a {\n    padding: 13px 20px 13px 28px;\n    font-size: 13px;\n    color: var(--grigioScuro) !important;\n}\n.dropdown-menu li:first-child a {\n    border-radius: 10px 10px 0px 0px;\n}\n.dropdown-menu li:last-child a {\n    border-radius: 0px 0px 10px 10px;\n}\n\n\n\n/*Bottoni*/\n.navbar .bottone {\n    font-size: 16px !important;\n    font-weight: 600;\n    margin-right: 16px;\n}\n.bottoni a {\n    color: var(--principale);\n}\n\n.logoMenu {\n    width: 160px;\n}\n\n.navbar-nav .vociMenu {\n    display: flex;\n}\n\n\n\n/*Voci solo a mobile*/\n.solo-mobile {\n    display: none;\n}\n@media only screen and (max-width: 992px) {\n    .solo-mobile {\n        display: block;\n    }\n    .dropdown {\n        display: none;\n    }\n}\n/*-------------------------------MOBILE MENU-----------------------------------*/\n/*Burger icon:*/\n.navbar .navbar-toggler {\n    border: none;\n    color: var(--principale);\n}\n.navbar .navbar-toggler:focus {\n    border: none;\n}\n.navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 103, 163, 1)' stroke-linecap='' stroke-miterlimit='10' stroke-width='3' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n/*Close button:*/\n.navbar .close-button {\n    display: none;\n    background: none;\n    border: none;\n    font-weight: 900;\n    color: var(--principale);\n}\n\n\n/* Fa arrivare il menu a mobile da sx invece che dall'alto*/\n@media (max-width: 992px) {\n    .navbar-collapse.collapsing .navbar-nav {\n        display: block;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: -45%;\n        transition: all 0.2s ease;\n    }\n    .navbar-collapse.show .navbar-nav {\n        background: var(--secondario);\n        z-index: 9;\n        width: 100%;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        flex-direction: column;\n        height: auto;\n        transition: left 0.35s ease;\n        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    }\n    .navbar-nav .vociMenu {\n        display: block;\n        padding: 30px 20px 40px 20px;\n    }\n    .navbar-nav .vociMenu a {\n        color: var(--white) !important;\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 20px;\n        padding: 14px 0px 14px 0px;\n    }\n    .navbar-nav li .bottoni {\n        display: none;\n    }\n    /*Close button*/\n    .navbar .close-button {\n        display: block;\n        position: absolute;\n        top: 35px;\n        right: 35px;\n    }\n}\n\n\n/*Contenuto Top del menu mobile aperto*/\n.container-top-menu-mobile .logo {\n    margin-bottom: 20px;\n}\n.container-top-menu-mobile {\n    display: none;\n    padding: 60px 25px 33px 25px;\n    background: var(--white);\n}\n@media only screen and (max-width: 992px) {\n    .container-top-menu-mobile {\n        display: block;\n    }\n}\n.navbar-nav .onda {\n    transform: translateY(-2px);\n}\n.navbar-nav .onda path {\n    fill: var(--white);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
